import { HeroEvent as UIKitHeroEvent } from '@sbercloud/uikit-product-site-hero';
import { useMemo } from 'react';

import { useAnalytics } from '../../../hooks/useAnalytics';
import { useLayoutType } from '../../../hooks/useLayoutType';
import { EventOrWebinarType } from '../../../types/backendContent';
import { useBreadcrumbs } from './hooks';
import {
  getAudience,
  getEventCategoryMetaProps,
  getFormat,
  getHeroBackgroundColor,
  getHeroButtonProps,
  getPlaceProps,
} from './utils';

type Props = {
  event: EventOrWebinarType;
  onClickButton?: () => void;
};

export function HeroEvent({ event, onClickButton }: Props) {
  const layoutType = useLayoutType();

  const { clickAnalytics } = useAnalytics();
  const breadcrumbs = useBreadcrumbs(event, clickAnalytics);

  const categoryTagMeta = useMemo(
    () => getEventCategoryMetaProps(event),
    [event],
  );

  return (
    <UIKitHeroEvent
      title={event.title}
      startsAt={`${event.startsAt} ${event.nameTimeZone || 'мск'}`}
      place={getPlaceProps(event.place)}
      image={event.image}
      backgroundColor={getHeroBackgroundColor()}
      category={categoryTagMeta}
      format={getFormat(event)}
      audience={getAudience(event)}
      breadcrumbs={breadcrumbs}
      button={getHeroButtonProps(event, clickAnalytics, onClickButton)}
      layoutType={layoutType}
    />
  );
}
